import SectionHeader from "../eventsExperiences/SectionHeader";
import fitImg from "../../assets/images/eventsExperiences/services/talent.jpg";
import supportImg from "../../assets/images/whatwedo/celebrityMarketing/endToEndSupport.jpg";
import impactImg from "../../assets/images/eventsExperiences/services/concept.jpg";
import networkImg from "../../assets/images/eventsExperiences/services/content.jpg";

const REASONS = [
  { tone: "dark", image: fitImg, title: "Right Fit, Every Time", desc: "We match the right celebrity with your brand, audience and goals.", tags: "Brand · Audience · Goals" },
  { tone: "light", image: supportImg, title: "End-to-End Support", desc: "From ideation to execution, we manage the entire collaboration.", tags: "Ideation · Contracts · Execution" },
  { tone: "dark", image: impactImg, title: "Impactful Campaigns", desc: "Create authentic and memorable campaigns that drive visibility, engagement and results.", tags: "Visibility · Engagement · Results" },
  { tone: "red", image: networkImg, title: "Trusted Network", desc: "Access to a curated network of celebrities, talent managers and industry professionals.", tags: "Celebrities · Talent managers · Industry" },
];

// Same staircase cards as the Influencer "How it works" section (.im-step-* in influencerMarketing.css).
const CelebWhy = () => (
  <section className="ee-section">
    <div className="container">
      <SectionHeader
        eyebrow="Why HKI"
        title="More than just"
        accent="a booking."
        intro="We combine industry relationships, campaign expertise and on-ground execution to deliver collaborations that create real value."
      />
      <div className="im-steps">
        {REASONS.map(({ tone, image, title, desc, tags }, i) => (
          <article className={`im-step im-step--${tone}`} key={title} style={{ "--i": i }}>
            <div className="im-step-copy">
              <h3><span>0{i + 1}</span> {title}</h3>
              <p>{desc}</p>
              <small>{tags}</small>
            </div>
            <img className="im-step-img" src={image} alt="" loading="lazy" />
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default CelebWhy;
